export { default } from "./src/container";
export type {
    UniformContainerProps,
    BackgroundImageFit
} from "./src/container";
